import { render, staticRenderFns } from "./AiOperationConfigBook.vue?vue&type=template&id=13bf7569&scoped=true"
import script from "./AiOperationConfigBook.vue?vue&type=script&lang=js"
export * from "./AiOperationConfigBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf7569",
  null
  
)

export default component.exports